import { Component, OnInit } from '@angular/core';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-add-company',
  templateUrl: './add-company.component.html',
  styleUrls: ['./add-company.component.scss']
})
export class AddCompanyComponent implements OnInit {
  items: MenuItem[];
  constructor() { }
  checked: boolean;

  ngOnInit(): void {
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
    ];
  }

}
